import type { IModuleAction } from './interface';
import actions from './slice';
import { dispatchAction as dispatch } from './store';

function Action(): IModuleAction {
    return {
        reset: () => {
            dispatch(actions.reset());
        },
        updateHeadingText: (newText: string) => {
            dispatch(actions.updateHeadingText(newText));
        },
        updateSubHeadingText: (newText: string) => {
            dispatch(actions.updateSubHeadingText(newText));
        },
    };
}

export default Action;
